import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { GroupMenu } from './components/GroupMenu';

export const GroupSelector: React.FC<{ isDisabled: boolean }> = (props) => {
  const methods = useFormContext();
  const {
    formState: { errors },
  } = methods;

  return (
    <FormControl isRequired isInvalid={!!errors.group?.message}>
      <Controller
        name="group"
        rules={{ required: 'Group is required' }}
        render={({ field: { onChange, value, ref, onBlur } }) => (
          <GroupMenu
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            ref={ref}
            {...props}
          />
        )}
      />
      <FormErrorMessage>{errors.group?.message}</FormErrorMessage>
    </FormControl>
  );
};
